import React, {useState} from 'react';
import styled from 'styled-components';
import {EnvConfig} from "../../Shared/Constants/environtmentConstants";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import {SaveExternalLeadUnicContactHook} from "./hook/saveExternalLeadUnicContactHook";
import {ExternalLeadType} from "./type/externalLeadType";

const Section = styled.section`
    width: 100%;
    font-family: sans-serif;
    background-color: white;
    padding: 40px 10px;
`;

const HeadingWrapper = styled.div`
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
`;

const TitleSmall = styled.h2`
    font-size: 1.5rem;
    font-weight: bold;
    color: #1a237e;
    margin-bottom: 8px;
`;

const TitleLarge = styled.h1`
    font-size: 2.5rem;
    font-weight: bold;
    color: #1a237e;
    margin-bottom: 0;
`;

const Container = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    align-items: flex-start;
    justify-content: center;
`;

const ImageWrapper = styled.div`
    flex: 1;
    min-width: 200px;
`;

const StyledImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
`;

const FormWrapper = styled.div`
    flex: 1;
    min-width: 300px;
    background-color: #f0f4f8;
    padding: 30px;
    border-radius: 10px;
`;

const FormLabel = styled.label`
    display: block;
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
`;

const FormInput = styled.input`
    width: 100%;
    padding: 10px;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
`;

const Button = styled.button`
    background-color: #1a237e;
    color: #fff;
    margin-top: 20px;
    padding: 12px 20px;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
    cursor: pointer;

    &:hover {
        background-color: #3949ab;
    }
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 12px;
`;

const ToggleButton = styled.button<{ $active: boolean }>`
    padding: 10px 16px;
    background-color: ${({$active}) => ($active ? '#1a237e' : '#e0e7ff')};
    color: ${({$active}) => ($active ? '#fff' : '#1a237e')};
    border: none;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
        background-color: #1a237e;
        color: #fff;
    }
`;

const FinalNote = styled.p`
    font-size: 1rem;
    color: #000;
    text-align: center;
    margin-top: 40px;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
`;

const HeaderLeadMainSectionUnic: React.FC = () => {
    const [formData, setFormData] = useState<ExternalLeadType>({
        email: '',
        phone: '',
        address: '',
        type: ''
    });
    const [step, setStep] = useState(0);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const changeLocationData = (key: string, value: any) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value,
        }));
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!formData.email || !formData.phone || !formData.address || !formData.type) {
            alert('Por favor, completa todos los campos');
            return;
        }

        SaveExternalLeadUnicContactHook(formData)
            .then((response) => {
                if (response.status === 200) {
                    setFormData({email: '', phone: '', address: '', type: ''});
                    setStep(1);
                } else {
                    alert('Error al enviar el formulario. Intenta nuevamente.');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                alert('Error al enviar el formulario. Intenta nuevamente.');
            });
    };


    const handleStepChange = () => {
        if (step === 0) {
            return (
                <FormWrapper>
                    <form onSubmit={handleSubmit}>
                        <FormLabel>Formulario</FormLabel>
                        <FormInput
                            type="email"
                            name="email"
                            placeholder="Correo electrónico"
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                        <FormInput
                            type="tel"
                            name="phone"
                            placeholder="Teléfono"
                            value={formData.phone}
                            onChange={handleInputChange}
                        />

                        <GooglePlacesAutocomplete
                            apiKey={EnvConfig().google_places_api_key}
                            apiOptions={{
                                region: 'es'
                            }}
                            selectProps={{
                                defaultInputValue: formData.address,
                                placeholder: 'Ej: nombre de la calle, 123, Ciudad',
                                onChange: (e: any) => changeLocationData('address', e.label),
                                instanceId: 'react-select-3-live-region',
                                className: 'selectFormValueCustomStyled',
                                classNames: {
                                    control: () => {
                                        return 'selectInputCustomStyled'
                                    },
                                    menu: () => {
                                        return 'selectMenuCustomStyled';
                                    }
                                }
                            }}
                        />

                        <FormLabel>Tipo de alquiler</FormLabel>
                        <ButtonGroup>
                            <ToggleButton
                                $active={formData.type === 'tourist'}
                                onClick={() => setFormData({ ...formData, type: 'tourist' })}
                                type="button"
                            >
                                Turístico
                            </ToggleButton>
                            <ToggleButton
                                $active={formData.type === 'temporary'}
                                onClick={() => setFormData({ ...formData, type: 'temporary' })}
                                type="button"
                            >
                                Temporal
                            </ToggleButton>
                        </ButtonGroup>

                        <Button type={'submit'}>
                            {'Enviar'}
                        </Button>

                    </form>
                </FormWrapper>
            );
        } else {
            return (
                <FormWrapper>
                    <h2>Gracias por registrarte</h2>
                    <p>Te contactaremos pronto para ayudarte con el trámite.</p>
                    <Button onClick={() => setStep(0)}>Volver</Button>
                </FormWrapper>
            );
        }
    }

    return (
        <Section>
            <HeadingWrapper>
                <TitleSmall>Te ayudamos con el trámite</TitleSmall>
                <TitleLarge>Ventanilla Única Digital</TitleLarge>
            </HeadingWrapper>

            <Container>
                <ImageWrapper>
                    <StyledImage
                        src="img2.jpg"
                        alt="Pareja llegando al alojamiento"
                    />
                </ImageWrapper>

                {handleStepChange()}
            </Container>

            <FinalNote>
                ¿Tienes una propiedad turística o temporal? A partir del 1 de julio de 2025,
                es obligatorio registrarla en la Ventanilla Única. Nosotros te ayudamos GRATIS
                a hacerlo paso a paso.
            </FinalNote>
        </Section>
    );
};

export default HeaderLeadMainSectionUnic;